(function ($) {
  'use strict';
  var focusable = 'a[href],button,input,select,textarea,[tabindex],iframe,video[controls]';
  var saved = new WeakMap();
  function retainFocus(slide, active, carousel) {
    if (active || !slide.contains(document.activeElement)) return;
    var control=carousel.querySelector('.owl-nav button:not([disabled]),.slick-arrow:not([disabled]),.slick-dots button');
    if (control && !slide.contains(control)) control.focus({preventScroll:true});
    else {carousel.setAttribute('tabindex','-1');carousel.focus({preventScroll:true});}
  }
  function expose(slide, active) {
    retainFocus(slide,active,slide.closest('.owl-carousel'));
    slide.setAttribute('aria-hidden', String(!active));
    slide.inert = !active;
    slide.querySelectorAll(focusable).forEach(function (el) {
      if (!saved.has(el)) saved.set(el, el.getAttribute('tabindex'));
      if (!active) el.setAttribute('tabindex','-1');
      else {
        var value = saved.get(el);
        if (value === null) el.removeAttribute('tabindex'); else el.setAttribute('tabindex',value);
      }
    });
  }
  function syncOwl(element) {
    element.querySelectorAll('.owl-item').forEach(function (slide) {
      expose(slide,slide.classList.contains('active'));
      // Owl copies IDs verbatim. Give each duplicate a private namespace and repair its references.
      if (slide.classList.contains('cloned') && !slide.dataset.idsScoped) {
        slide.dataset.idsScoped='true';
        var suffix='-owl-copy-'+Array.from(element.querySelectorAll('.owl-item')).indexOf(slide);
        var ids={};
        slide.querySelectorAll('[id]').forEach(function (el) {ids[el.id]=el.id+suffix;el.id+=suffix;});
        slide.querySelectorAll('[for],[aria-labelledby],[aria-describedby],[aria-controls]').forEach(function (el) {
          ['for','aria-labelledby','aria-describedby','aria-controls'].forEach(function (attr) {
            if(el.hasAttribute(attr)) el.setAttribute(attr,el.getAttribute(attr).split(' ').map(function (id) {return ids[id]||id;}).join(' '));
          });
        });
      }
    });
    element.querySelectorAll('.owl-prev,.owl-next').forEach(function (b) {
      b.setAttribute('aria-label',b.classList.contains('owl-prev')?'Previous products':'Next products');
      b.disabled=b.classList.contains('disabled') || b.parentElement.classList.contains('disabled');
    });
    var dots=element.querySelectorAll('.owl-dot');
    dots.forEach(function (b,i) { b.setAttribute('aria-label','Show product group '+(i+1)+' of '+dots.length); b.setAttribute('aria-current',b.classList.contains('active')?'true':'false'); });
  }
  function syncSlick(element) {
    var slides=element.querySelectorAll('.slick-slide');
    // Slick may have written -1 for inactive descendants; active product links use their native tab stop.
    slides.forEach(function (slide) {
      var active=slide.classList.contains('slick-active');
      retainFocus(slide,active,element);
      slide.inert=!active;
      slide.setAttribute('aria-hidden',String(!active));
      if (element.classList.contains('fl-product-media-sidebar')) {
        slide.setAttribute('role','button');
        slide.setAttribute('aria-pressed',String(slide.classList.contains('slick-current')));
        slide.setAttribute('tabindex',active?'0':'-1');
        var image=slide.querySelector('img');
        slide.setAttribute('aria-label','Show '+(image && image.alt ? image.alt : 'product media'));
      }
      slide.querySelectorAll('[id=""]').forEach(function (el) {el.removeAttribute('id');});
      slide.querySelectorAll('a[href],button,input,select,textarea').forEach(function (el) {el.setAttribute('tabindex',active?'0':'-1');});
    });
    var dots=element.querySelector('.slick-dots');
    if(!dots) return;
    dots.removeAttribute('role');
    var buttons=dots.querySelectorAll('button');
    buttons.forEach(function (button,i) {
      button.parentElement.removeAttribute('role');
      ['role','aria-controls','aria-selected'].forEach(function (attr) {button.removeAttribute(attr);});
      button.setAttribute('aria-label','Show slide group '+(i+1)+' of '+buttons.length);
      button.setAttribute('aria-current',button.parentElement.classList.contains('slick-active')?'true':'false');
      button.setAttribute('tabindex','0');
    });
    slides.forEach(function (slide) { if(slide.getAttribute('role')==='tabpanel') slide.setAttribute('role','group');slide.removeAttribute('aria-describedby'); });
  }
  // Queue after the libraries finish writing their own accessibility attributes.
  $(document).on('initialized.owl.carousel translate.owl.carousel translated.owl.carousel refreshed.owl.carousel', '.owl-carousel', function () {
    var el=this; Promise.resolve().then(function () {syncOwl(el);});
  });
  $(document).on('init reInit beforeChange afterChange breakpoint setPosition', '.related-products-slider,.fl-product-media-slider,.fl-product-media-sidebar,.media_slider_area', function () {
    var el=this; Promise.resolve().then(function () {syncSlick(el);});
  });
  function initialSync() {
    document.querySelectorAll('.owl-carousel.owl-loaded').forEach(syncOwl);
    document.querySelectorAll('.related-products-slider.slick-initialized,.fl-product-media-slider.slick-initialized,.fl-product-media-sidebar.slick-initialized,.media_slider_area.slick-initialized').forEach(syncSlick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialSync);
  else initialSync();
})(window.jQuery);
